import styled from 'styled-components';

const Text = styled.div`
  color: ${({ theme }) => theme.text.tableVulnName};
  cursor: pointer;
`;

export default Text;
